export default {
    SET_CART(state, cart) {
        state.cart = cart;
    },

    SET_METHOD(state, method) {
        state.method = method;
    },

    SET_CARD_BRAND(state, cardBrand) {
        state.cardBrand = cardBrand
    }

}



// WEBPACK FOOTER //
// ./resources/assets/js/store/components/store/mutations.js